import { createPinia } from 'pinia'
import vuetify from './plugins/vuetify'

import App from './App.vue'
import { createApp } from 'vue'
import { JazelAppConfig } from '@jazel/jazel-vuetify'
import { config } from './config/generated-config'

const app = createApp(App)
const pinia = createPinia()

app.use(vuetify)
app.use(pinia)
app.use(JazelAppConfig, {
  productId: 'scan2sell',
  isEmbedded:
    document.getElementById('scan2sell-admin-ui')?.parentNode !== document.body,
  cdnUrl: config.VITE_CDN_URL,
  jamsFrontendUrl: config.VITE_JAMS_FRONTEND_URL,
  jamsBackendUrl: config.VITE_JAMS_BACKEND_URL,
})
app.mount('#scan2sell-admin-ui')
